import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setProfileByProfileKey
} from '../redux/users'

export default function * fetchProfile (action) {
  const { profileKey } = action.payload

  yield put(setProfileByProfileKey({
    profileKey,
    profile: {
      isLoading: true,
      isLoaded: false
    }
  }))

  try {
    const {
      Profile,
      CanEditKanBoProfile,
      CanEditRemoteProfile,
      CanSyncRemoteProfile,
      CanUploadAvatar
    } = yield call(apiGetData, 'GetProfile', {
      profileKey
    })

    yield put(setProfileByProfileKey({
      profileKey,
      profile: {
        canEditKanBoProfile: CanEditKanBoProfile,
        canEditRemoteProfile: CanEditRemoteProfile,
        canSyncRemoteProfile: CanSyncRemoteProfile,
        canUploadAvatar: CanUploadAvatar,
        fields: {
          name: Profile.Name,
          surname: Profile.Surname,
          email: Profile.Email,
          phone: Profile.Phone,
          aboutMe: Profile.AboutMe,
          askMeAbout: Profile.AskMeAbout,
          profileLink: Profile.ProfileLink
        },
        isLoading: false,
        isLoaded: true
      }
    }))
  } catch (error) {
    yield put(setProfileByProfileKey({
      profileKey,
      profile: {
        isLoading: false,
        isLoaded: false
      }
    }))

    throw error
  }
}
